var findAccount = function (accounts, accountId) {
    return accounts === null || accounts === void 0 ? void 0 : accounts.find(function (account) { return account.info["cipher.accountId"] === accountId; });
};
export default findAccount;
//# sourceMappingURL=findAccount.js.map